import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import API from '../utils/api';
import { useLoginModal } from '../context/LoginModalContext';
import { useAdminLoginModal } from '../context/AdminLoginModalContext';

const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || '';

export default function Footer() {
  const { t } = useTranslation();
  const [settings, setSettings] = useState({});
  const { openLogin } = useLoginModal();
  const { openAdminLogin } = useAdminLoginModal();

  useEffect(() => {
    API.get('/settings').then(r => setSettings(r.data)).catch(() => {});
  }, []);

  const logoImageUrl = settings.logoImage ? (settings.logoImage.startsWith('http') ? settings.logoImage : `${API_BASE}${settings.logoImage}`) : null;

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-brand-name">
              {logoImageUrl
                ? <img src={logoImageUrl} alt={settings.siteName} className="footer-brand-logo" />
                : '🐂'
              } {settings.siteName || 'Sri Bramaramba Mallikarjuna Swami Goshala'}
            </div>
            <p style={{ marginTop: 12 }}>
              {t('footer.tagline')}
            </p>
            <p style={{ marginTop: 8, fontSize: '0.85rem', color: '#777' }}>
              {settings.trustName && <><strong style={{ color: '#aaa' }}>{settings.trustName}</strong><br /></>}
              {settings.trustRegNo && <>{t('footer.regNo')}: {settings.trustRegNo}<br /></>}
              {settings.section80GNo && <>{t('footer.section80G')}: {settings.section80GNo}</>}
            </p>
            <div className="footer-social">
              <a href="#"><i className="fab fa-facebook-f" /></a>
              <a href="#"><i className="fab fa-instagram" /></a>
              <a href="#"><i className="fab fa-youtube" /></a>
              <a href="#"><i className="fab fa-whatsapp" /></a>
            </div>
          </div>

          <div>
            <h4>{t('footer.quickLinks')}</h4>
            <ul>
              <li><Link to="/adopt-a-cow">{t('nav.adoptACow')}</Link></li>
              <li><Link to="/donations">{t('footer.donateNowLink')}</Link></li>
              <li><Link to="/gallery">{t('nav.gallery')}</Link></li>
              <li><Link to="/videos">{t('nav.videos')}</Link></li>
              <li><Link to="/activities">{t('nav.ourActivities')}</Link></li>
              <li><Link to="/slokas">{t('nav.slokas')}</Link></li>
            </ul>
          </div>

          <div>
            <h4>{t('footer.information')}</h4>
            <ul>
              <li><Link to="/about-us">{t('nav.aboutUs')}</Link></li>
              <li><Link to="/management">{t('nav.management')}</Link></li>
              <li><Link to="/faqs">{t('nav.faqs')}</Link></li>
              <li><Link to="/my-donations">{t('nav.myDonations')}</Link></li>
              <li><button type="button" className="footer-link-btn" onClick={openLogin} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', font: 'inherit' }}>{t('footer.loginRegister')}</button></li>
            </ul>
          </div>

          <div>
            <h4>{t('footer.contact')}</h4>
            <ul>
              {settings.contactPhone && <li><a href={`tel:${settings.contactPhone}`}><i className="fas fa-phone" style={{ marginRight: 8 }} />{settings.contactPhone}</a></li>}
              {settings.contactEmail && <li><a href={`mailto:${settings.contactEmail}`}><i className="fas fa-envelope" style={{ marginRight: 8 }} />{settings.contactEmail}</a></li>}
              {settings.address && <li style={{ color: '#aaa', fontSize: '0.85rem', lineHeight: 1.5 }}><i className="fas fa-map-marker-alt" style={{ marginRight: 8 }} />{settings.address}</li>}
              {settings.upiId && (
                <li style={{ marginTop: 8 }}>
                  <span style={{ color: '#888', fontSize: '0.8rem' }}>{t('footer.upiLabel')}</span><br />
                  <span style={{ color: '#fff', fontFamily: 'monospace', fontSize: '0.85rem' }}>{settings.upiId}</span>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>{t('footer.rightsLine', { year: new Date().getFullYear() })}</p>
          <p className="footer-admin-portal" style={{ marginTop: 4, fontSize: '0.8rem' }}>
            <button type="button" onClick={openAdminLogin} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', font: 'inherit', color: '#555', fontSize: '0.8rem' }}>{t('footer.adminPortal')}</button>
          </p>
        </div>
      </div>
    </footer>
  );
}
